import axios from '@/axios'

const actions = {
  setTeams: ({ commit, state }, { force } = {}) => {
    if (!force && state.teams.length) return Promise.resolve() // cache; { force } após criar time
    return axios
      .teams
      .fetch(
        { url: '/get_teams' }
      )
      .then((response) => {
        return commit('teams', response)
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
      })
  },
  setCreateTeam: ({ dispatch }, team) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .create(team)
      .then((response) => {
        dispatch('setTeams', { force: true }) // recarrega a lista com o novo time
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  // Detalhe da equipe (dados + membros + robôs) → commit em currentTeam.
  setTeamDetail: ({ commit, dispatch }, { team_id }) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .getTeam({ team_id })
      .then((response) => {
        commit('currentTeam', response)
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setUpdateTeam: ({ dispatch }, payload) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .update(payload)
      .then((response) => {
        dispatch('setTeamDetail', { team_id: payload.team_id })
        dispatch('setTeams', { force: true })
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setAddTeamMember: ({ dispatch }, payload) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .addMember(payload)
      .then((response) => {
        if (response && response.success) {
          dispatch('setTeamDetail', { team_id: payload.team_id })
        }
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setRemoveTeamMember: ({ dispatch }, payload) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .removeMember(payload)
      .then((response) => {
        dispatch('setTeamDetail', { team_id: payload.team_id })
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setTeamImage: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .teams
      .post
      .setImage(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  fetchTeamImage: (context, teamId) => {
    return axios
      .teams
      .post
      .getImage({ team_id: teamId })
      .then((response) => (response && response.image) || '')
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return ''
      })
  }
}

export default actions
